/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.querySelectorAll('[data-grid-item]').forEach(item => {
    const priceEl = item.querySelector('[data-product-price]');
    if (!priceEl) return;

    // Capture whether this product uses a "From" prefix at page-load time,
    // before Broadcast's sibling JS ever touches the element.
    const hadFrom = priceEl.innerHTML.includes('<small>');

    const observer = new MutationObserver(() => {
      // Find whichever sibling swatch is currently being hovered.
      const swatch = item.querySelector('tooltip-component[data-sibling-link]:hover');
      if (!swatch) return;

      const comparePrice = swatch.getAttribute('data-sibling-compare-at-price');
      const priceSpan = priceEl.querySelector('.price');
      if (!priceSpan) return;

      if (comparePrice && comparePrice.trim() !== '') {
        // Sale sibling: Broadcast has already written the new price text into
        // .price but without the new-price/old-price wrapper structure.
        // Only rebuild if we haven't already done so.
        if (priceSpan.querySelector('.old-price')) return;

        const currentPrice = priceSpan.innerHTML;
        priceSpan.classList.add('sale');
        priceSpan.innerHTML =
          `<span class="new-price">${hadFrom ? '<small>From </small>' : ''}${currentPrice}</span>` +
          `<span class="old-price">${comparePrice}</span>`;

      } else {
        // Non-sale sibling: Broadcast has written the price text but stripped
        // the <small>From</small> prefix. Re-add it if the product needs it.
        if (!hadFrom) return;
        if (priceSpan.querySelector('small')) return; // already there

        const currentPrice = priceSpan.innerHTML;
        priceSpan.innerHTML = `<span class="new-price"><small>From </small>${currentPrice}</span>`;
      }
    });

    observer.observe(priceEl, { childList: true, subtree: true });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
